import { TenantType } from '../enums'
import { ManagementTenant } from '../models'

export const isFoodTenant = (tenant?: ManagementTenant) => tenant?.type === TenantType.FOOD
export const isServiceTenant = (tenant?: ManagementTenant) => tenant?.type === TenantType.SERVICE
